/* istanbul ignore file */
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';

const EditProjectWeeklyReportButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useProjectWeeklyReportsUrl();

  return <EditButton {...props} path={getUpdateEntityUrl} />;
};

export default EditProjectWeeklyReportButton;
